import { useCallback, useContext } from "react";
import { NormalizedSubscription } from "@memento/types/subscription";
import type { Card } from "@memento/types/card";
import { AdsContext } from "src/components/Ads/AdSlotsProvider";
import { canUseFeature, Feature } from "@memento/library/feature-access";
import { useFeatureFlags } from "src/contexts/FeatureFlagProvider";

export function useAds() {
  const { featureFlags } = useFeatureFlags();
  const { enabled, setEnabled } = useContext(AdsContext);

  const updateAds = useCallback(
    (
      card: Card | null | undefined,
      subscription: NormalizedSubscription | null | undefined
    ): void => {
      const isRemoveAds = canUseFeature(
        Feature.GroupVideosRemoveAds,
        subscription ?? null,
        {
          card: card ?? null,
          featureFlags,
        }
      );
      setEnabled(!isRemoveAds);
    },
    [setEnabled, featureFlags]
  );

  return {
    setAdsEnabled: setEnabled,
    adsEnabled: enabled,
    updateAds: updateAds,
  };
}
